if (!customElements.get("m-size-chart")) {
  customElements.define(
    "m-size-chart",
    class MSizeChart extends HTMLElement {
      connectedCallback() {
        // 获取唯一 ID，将前缀更换为 size-chart-
        const uid = this.getAttribute("id").replace("size-chart-", "");
        // 查找触发按钮和内容节点
        this.openBtn = this.querySelector(`[data-open-chart="${uid}"]`);
        this.contentNode = document.getElementById(`chart-content-${uid}`);

        if (this.contentNode && this.contentNode.innerHTML) {
          this.content = this.contentNode.innerHTML;
          this.init();
        }
      }

      init() {
        this.modal = new MinimogTheme.Modal();
        this.openBtn?.addEventListener("click", (e) => {
          e.preventDefault();
          if (this.content) {
            const html = document.createElement("DIV");
            // 更新类名为 m-size-chart__content
            html.classList.add("m-size-chart__content");
            html.innerHTML = this.content;
            this.modal.appendChild(html);

            const colorScheme = html.querySelector("[data-color-scheme]")?.dataset.colorScheme || "default";
            // 更新 Modal 的类名标识
            this.modal.setSizes(`m-size-chart m-gradient ${colorScheme}`);
            this.modal.open();
          }
        });
      }
    }
  );
}